import { LookupId } from '../../lists/lookups.enum';
import { LookupKeys } from 'ag-common-lib/lib/models/crm/lookup.model';

export enum SocialKeys {
  id = 'id',
  url = 'url',
  accountId = 'accountId', // label: User Name
  accountType = 'accountType',
  socialMedia = 'social_media',
  socialType = 'social_type',
}

export class Social {
  [SocialKeys.id]?: string;
  /**
   * @deprecated Use accountId instead
   */
  [SocialKeys.url]?: string;
  [SocialKeys.accountId]?: string;
  [SocialKeys.accountType]?: LinkedInType | YoutubeType;
  [SocialKeys.socialMedia]?: LookupId<'AgencySocialMedia'> | LookupId<'SocialMedia'>;
  [SocialKeys.socialType]?: LookupId<'AgencySocialTypes'> | LookupId<'SocialTypes'>;
}

export enum YoutubeType {
  ChannelName = 'c/',
  ChannelId = 'channel/',
  Default = '@',
  User = 'user/',
}

export const YOUTUBE_TYPE_LOOKUP = [
  {
    [LookupKeys.value]: YoutubeType.ChannelName,
    [LookupKeys.description]: 'Channel Name',
  },
  {
    [LookupKeys.value]: YoutubeType.ChannelId,
    [LookupKeys.description]: 'Channel ID',
  },
  {
    [LookupKeys.value]: YoutubeType.Default,
    [LookupKeys.description]: 'Channel Handle',
  },
  {
    [LookupKeys.value]: YoutubeType.User,
    [LookupKeys.description]: 'User Name',
  },
];

export enum LinkedInType {
  Company = 'company/',
  Public = 'in/',
}

export const LINKED_IN_TYPE_LOOKUP = [
  {
    [LookupKeys.value]: LinkedInType.Company,
    [LookupKeys.description]: 'Company',
  },
  {
    [LookupKeys.value]: LinkedInType.Public,
    [LookupKeys.description]: 'Public',
  },
];

export const socialMediaUrlMap = {
  FB: 'https://www.facebook.com/',
  IG: 'https://www.instagram.com/',
  LI: 'https://www.linkedin.com/',
  TW: 'https://x.com/',
  YT: 'https://www.youtube.com/',
  TT: 'https://www.tiktok.com/',
};

export const socialMediaIconMap = {
  FB: 'agi-facebook-f',
  IG: 'agi-instagram',
  LI: 'agi-linkedin-in',
  TW: 'agi-twitter-x',
  YT: 'agi-youtube',
  AC: 'assets/images/ag-logo-sm-blue.png',
  AG: 'agi-alliance-campaigns',
  TT: 'agi-tiktok',
};
